import { Typography } from "@mui/material";
import React from "react";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import Body from "../../ui/Body";

import Coupon from "./Coupon";

export default function CouponList() {

  return (
    <>
      <Sidebar />
      <Nabvar />
      <Body>
        <Coupon />
      </Body>
    </>
  );
}
